/*
 * GET VARIANTS
 * Returns variant and inclusive variant.
 */
function getVariants() {
  let variant = null;
  let inclusiveVariant = null;
  let exclusiveVariant = null;
  let options = [];
  options[1] = null;
  options[2] = null;
  options[3] = null;

  // Get the variant options to set search product variants with.
  document.querySelectorAll('.js--variant-option').forEach(function (el) {
    if ((el.tagName.toLowerCase() == 'input' && el.checked == true) || el.classList.contains('js--vat-option')) {
      let option = el.name.replace('option', '');
      let optionValue = el.value;
      options[option] = optionValue;
    }
  });
  let inclusive = options;
  let exclusive = options;

  // Get the default exclusive variant. Exclusive will only be the default if
  // the customer hasn't checked a VAT preference. If they have, `variant` will
  // contain the inclusive or exclusive value based on their saved preference.
  // Important: This object will contain the variant ID to pass to cart.
  for (let i = 0; i < productVariants.length; i++) {
    if (
      productVariants[i].option1 == options[1] &&
      productVariants[i].option2 == options[2] &&
      productVariants[i].option3 == options[3]
    ) {
      variant = productVariants[i];
      break;
    }
  }

  // Get the actual exclusive variant.
  exclusive[vatOptionField] = vatOptionValues.exclusive;
  for (let i = 0; i < productVariants.length; i++) {
    if (
      productVariants[i].option1 == exclusive[1] &&
      productVariants[i].option2 == exclusive[2] &&
      productVariants[i].option3 == exclusive[3]
    ) {
      exclusiveVariant = productVariants[i];
      break;
    }
  }

  // Get the actual inclusive variant.
  inclusive[vatOptionField] = vatOptionValues.inclusive;
  for (let i = 0; i < productVariants.length; i++) {
    if (
      productVariants[i].option1 == inclusive[1] &&
      productVariants[i].option2 == inclusive[2] &&
      productVariants[i].option3 == inclusive[3]
    ) {
      inclusiveVariant = productVariants[i];
      break;
    }
  }

  return {
    variant: variant,
    exclusiveVariant: exclusiveVariant,
    inclusiveVariant: inclusiveVariant,
  };
}

/*
 * CHECK AVAILABILITY
 * Checks the variant availability of selected options and disables the buy
 * button if applicable.
 */
function variantAvailability() {
  let items = getVariants();
  let btn = document.querySelector('.product-form__submit');
  let availability = false;

  // Set availability.
  if (items.variant != null && items.variant.available == true) {
    availability = true;
    btn.disabled = false;
    btn.querySelector('span').innerText = localeStrings.addToCart;
  } else {
    btn.disabled = true;
    btn.querySelector('span').innerText = localeStrings.soldOut;
  }

  if (items.variant == null) {
    return;
  }

  renderPriceBlock(localeStrings, items);

  // Set the variant ID and append the variant ID as a url parameter.
  if (items.variant !== undefined) {
    document.querySelectorAll('input[name="id"]').forEach(function (el) {
      el.value = items.variant.id;
    });
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, document.title, '?variant=' + items.variant.id);
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.js--variant-option').forEach(function (el) {
    el.addEventListener('change', function (event) {
      variantAvailability();
    });
  });
  variantAvailability();
});

/*
 * MONEY FORMAT
 * Formats money in javascript.
 */
function money(value) {
  value = value / 100;
  let string = value.toLocaleString(
    'en-GB',
    { style: 'currency', currency: Shopify.currency.active }
  );
  return string;
}

/*
 * FORMAT MONEY
 * Formats the passed value as money with currency symbol.
 * Referenced from https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
 */
var Shopify = Shopify || {};
Shopify.money_format = '${{ amount }}';
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/*
 * RENDER PRICES
 */
function renderPriceBlock(localeStrings, items){
  let vatInfoDialog = '';
  if (vatInfoPopupEnabled) {
    vatInfoDialog = `<button type="button" class="vat-help-button" onclick="vat_relief_info.showModal();">?</button>`;
  }

  // Display the VAT relief and non-vat relief pricing.
  let prices = `
    <div class="js--vat-exclusive-price vat-pricing">
      ${(items.variant.compare_at_price > items.variant.price) ? "<s>Was " + money(items.exclusiveVariant.compare_at_price) + "</s>" : ""}
      <div>
        <strong>${money(items.exclusiveVariant.price)}</strong> 
        <span class="vat-label">${localeStrings.excVatLabel}</span> 
        ${vatInfoDialog}
      </div>
    </div>
    
    <div class="js--vat-inclusive-price vat-pricing" style="display: none">
      ${(items.variant.compare_at_price > items.variant.price) ? "<s>Was " + money(items.inclusiveVariant.compare_at_price) + "</s>" : ""}
      <div>
        <strong>${money(items.inclusiveVariant.price)}</strong> 
        <span class="vat-label">${localeStrings.incVatLabel}</span>
        ${vatInfoDialog}
      </div>
    </div>`;

  // Display prices.
  document.querySelectorAll('.js--variant-prices').forEach(function (el) {
    el.innerHTML = prices;
  });
}
